import { Stack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { LoadingMessage } from "../../..";
import FullPageLoader from "../../../components/full-page-loader";
import Heading from "../../../components/Heading";
import RandomUsers from "../../../components/randomUsers/RandomUsers";
import { useGetState } from "../../../context/useGetState";
import AboutUser from "./AboutUser";
import Profile from "./Profile";
import {
  follow,
  getRandomTraders,
  getUserStories,
  notInterested,
  unFollow,
} from "./service";
import AllStories from "./stories/Stories";

function Discover() {
  const { state } = useGetState();
  const acct_type = state?.userInfo?.account_type;
  const [traders, setTraders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setBtnLoading] = useState(false);
  const [stories, setStories] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [anyRandomUser, setAnyRandomUser] = useState();
  const [refresh, setRefresh] = useState({});

  useEffect(() => {
    getRandomTraders(setTraders, setLoading);
    getUserStories(setStories, setLoading);
    
  }, [refresh]);
  useEffect(() => {
    setSelectedUser(traders?.[0]);
    const randomIndex = Math.floor(Math.random() * traders?.length);
    console.log('randomNumber: ', Math.floor(Math.random()));
    setAnyRandomUser(traders[randomIndex])
  }, [traders, refresh]);

  // Function to select a random trader from the traders array
  const selectRandomTrader = () => {
    const randomIndex = Math.floor(Math.random() * traders?.length);
    return traders[randomIndex];
  };

  const handleNotInterested = async (user) => {
    LoadingMessage();
    const formData = new FormData();
    formData.append("type", "user");
    formData.append("entity_id", user?.id);

    await notInterested(formData, setBtnLoading, setRefresh);

  };

  const handleFollow = async (userId, following) => {
    LoadingMessage();
    setBtnLoading(true);
    const formData = new FormData();
    formData.append("user_id", parseFloat(userId));
    if (following) {
      await unFollow(userId, setBtnLoading);
    } else {
      await follow(userId, setBtnLoading);
    }
    setRefresh({});
  };

  return (
    <Stack alignItems={"flex-start"}>
      <AllStories acctType={acct_type} stories={stories} />
      {loading ? (
        <FullPageLoader />
      ) : (
        <>
          <Heading mt="25px !important" mb="10px !important">
            Discover
          </Heading>
          <Stack direction={["column", "row"]} spacing="20px" w="100%">
            <AboutUser
              user={state?.userInfo}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              handleFollow={handleFollow}
              handleNotInterested={handleNotInterested}
              anyRandomUser={anyRandomUser}
            />
            <Profile />
          </Stack>

          <RandomUsers
            traders={traders}
            setSelectedUser={setSelectedUser}
            handleFollow={handleFollow}
            acctType={acct_type}
            setBtnLoading={setBtnLoading}
            handleNotInterested={handleNotInterested}
            setRefresh={setRefresh}
          />
        </>
      )}
    </Stack>
  );
}

export default Discover;
